// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../public/scheduleTable/chair.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chair_listing {
  display: flex;
  list-style: none;
  justify-content: space-between;
  margin-left: 76px;
  margin-right: 20px;
  width: calc(100% - 97px);
}

.chair_item {
  flex: 0 0 20%;
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 4px 0;
  margin: 16px 0;
  border-right: 1px solid #ebeef2;
}

.chair_item:last-child {
  border-right: 1px solid transparent;
}

.chair_item_img_container {
  width: 32px;
  height: 32px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
}`, "",{"version":3,"sources":["webpack://./src/components/ScheduleComponents/ScheduleHeader/ScheduleChairString/ScheduleChairString.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,+BAAA;AACJ;;AACA;EACI,mCAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,oEAAA;AAEJ","sourcesContent":[".chair_listing {\r\n    display: flex;\r\n    list-style: none;\r\n    justify-content: space-between;\r\n    margin-left: 76px;\r\n    margin-right: 20px;\r\n    width: calc(100% - 97px);\r\n}\r\n\r\n.chair_item {\r\n    flex: 0 0 calc(100% / 5);\r\n    flex: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding: 4px 0;\r\n    margin: 16px 0;\r\n    border-right: 1px solid #ebeef2;\r\n}\r\n.chair_item:last-child {\r\n    border-right: 1px solid transparent;\r\n}\r\n\r\n.chair_item_img_container {\r\n    width: 32px;\r\n    height: 32px;\r\n    background: url(\"../../../../../public/scheduleTable/chair.png\") no-repeat\r\n        center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
